import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtDate } from "@/lib/api";
import { Loading, Empty } from "@/components/site/ui";
import StatusBadge from "@/components/StatusBadge";

export default function PortalReservations() {
  const [res, setRes] = useState(null);
  useEffect(() => { api.get("/portal/reservations").then((r) => setRes(r.data)).catch(() => setRes([])); }, []);
  return (
    <div>
      <h2 className="font-serif text-2xl mb-4">Your Reservations</h2>
      {res === null ? <Loading /> : res.length === 0 ? <Empty title="No reservations yet" /> : (
        <div className="space-y-3">
          {res.map((r) => (
            <Link key={r.id} to={`/portal/reservations/${r.id}`} data-testid={`portal-reslist-${r.id}`}
              className="glass rounded-lg p-5 flex justify-between items-center hover:glow-gold transition-shadow">
              <div>
                <p className="font-serif text-xl">{r.experience_title}</p>
                <p className="text-xs text-muted-foreground mt-1">{r.confirmation_number} · {fmtDate(r.arrival_date)} → {fmtDate(r.departure_date)}</p>
              </div>
              <StatusBadge status={r.status} />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
